import React, { useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { Copy } from '@grubhubprod/gh-cookbook-react';
import { DataTable } from 'src/components/DataTable';
import { buildCMUIPath, CMUIPage } from 'src/constants/urls';
import { createEmployeeListAdapter } from 'src/components/enterprise/features/Employee/EmployeeListPage/hooks/createEmployeeListAdapter';
import { EmployeeListTableDetailsLink } from 'src/components/enterprise/features/Employee/EmployeeListPage/components/EmployeeListTable/EmployeeListTableDetailsLink';
import { initialEmployeeListTableState } from 'src/components/enterprise/features/Employee/utils/employee.utils';
import { EmployeeSearchResultItem } from 'src/types/Employee';

enum EmployeeListTablePhoneColumnSpan {
  Name = 5,
  Email = 5,
  Actions = 2,
}

export function EmployeeListTable(): JSX.Element {
  const { corpid: corpId } = useParams<{ corpid: string }>();
  const adapter = useMemo(() => createEmployeeListAdapter(corpId), [corpId]);

  return (
    <DataTable.Provider
      adapter={adapter}
      initialState={initialEmployeeListTableState}
    >
      <DataTable.Container>
        <DataTable.TitleBar>
          <DataTable.Title x="sm">Active Employees</DataTable.Title>
          <DataTable.Summary />
        </DataTable.TitleBar>
        <DataTable.Toolbar>
          <DataTable.Search placeholder="Employee Name" />
        </DataTable.Toolbar>
        <DataTable.Content>
          <DataTable.Header>
            <DataTable.Column phone={EmployeeListTablePhoneColumnSpan.Name}>
              Employee Name
            </DataTable.Column>
            <DataTable.Column phone={EmployeeListTablePhoneColumnSpan.Email}>
              Email
            </DataTable.Column>
          </DataTable.Header>
          <DataTable.Body>
            {(employee: EmployeeSearchResultItem): JSX.Element => (
              <DataTable.Row key={employee.id} id={employee.id}>
                <DataTable.Cell phone={EmployeeListTablePhoneColumnSpan.Name}>
                  <Copy variant="body">
                    {`${employee.firstName} ${employee.lastName}`}
                  </Copy>
                </DataTable.Cell>
                <DataTable.Cell phone={EmployeeListTablePhoneColumnSpan.Email}>
                  <Copy variant="body">{employee.email}</Copy>
                </DataTable.Cell>
                <DataTable.Cell
                  phone={EmployeeListTablePhoneColumnSpan.Actions}
                  justifyContent="flex-end"
                >
                  <EmployeeListTableDetailsLink
                    href={buildCMUIPath(CMUIPage.EMPLOYEE_DETAILS, {
                      corpId,
                      employeeId: employee.id,
                    })}
                  />
                </DataTable.Cell>
              </DataTable.Row>
            )}
          </DataTable.Body>
          <DataTable.Footer>
            <DataTable.Pagination />
          </DataTable.Footer>
        </DataTable.Content>
      </DataTable.Container>
    </DataTable.Provider>
  );
}
